import type { Action } from 'react-sweet-state';
import { createStore } from 'react-sweet-state';

import { LIVE_PAGES_STORE_ID } from './constants';

type State = {
	isLive: boolean;
};

const initialState: State = {
	isLive: false,
};

const setIsLive =
	(isLive: boolean): Action<State> =>
	({ setState }) => {
		setState({ isLive });
	};

const actions = {
	setIsLive,
};

export const LivePagesStore = createStore({
	initialState,
	actions,
	name: LIVE_PAGES_STORE_ID,
});
